t = require('app/scripts/views/internal/teacup-with-helpers')('member_cards_date')

module.exports = ->
  t.div '.window-module-title', ->
    t.span { class: 'window-module-title-icon icon-lg icon-' + t.mustacheVar('iconType') }
    t.h3 ->
      t.text t.mustacheVar('header')
  t.div '.card-grid.u-gutter.u-clearfix.js-list'
